import AlertNotifications from './components/AlertNotifications'

const App = () => <AlertNotifications />

export default App